import { colors } from "../../Styles";

  export type Location = {
    locationId: number; //DataTYPE ID, static
    locationName: string;
  };
  
  export const LocationData: Location[] = [
    {
      locationId: 1,
      locationName: "Farrowing Unit",
    },
    {
      locationId: 2,
      locationName: "Weaner Unit"
    }
  ]

